import gql from 'graphql-tag';

const FULL_DELETE_USER = gql`
  mutation fullDeleteUser($Id: ID!, $confirmFullDelete: Boolean!) {
    fullDeleteUser(where: { id: $Id }, confirmFullDelete: $confirmFullDelete) {
      id
    }
  }
`;

export default FULL_DELETE_USER;
